//TODO: Coupling file to https://www.figma.com/file/jgdEzPBq6iXMYaj2OFO7wM/mustache---web-Kit
export const COLOR_TONE = {
  red: {
    10: '#FFE9E9',
    20: '#FFB8B8',
    30: '#FF8787',
    40: '#FF5656',
    50: '#FF2525',
    60: '#DB2020',
    70: '#B81B1B',
    80: '#941616',
    90: '#701010',
    100: '#4D0B0B',
  },
  purple: {
    10: '#E7E3F4',
    20: '#D7CEED',
    30: '#B6A6DD',
    40: '#947ECE',
    50: '#7356BF',
    60: '#624AA4',
    70: '#523D88',
    80: '#41316D',
    90: '#312551',
    100: '#201836',
  },
  blue: {
    10: '#DAE7FF',
    20: '#B5D0FF',
    30: '#8FB8FF',
    40: '#6AA1FF',
    50: '#4589FF',
    60: '#3B76DB',
    70: '#3263B8',
    80: '#285094',
    90: '#1E3C70',
    100: '#15294D',
  },
  teal: {
    10: '#D4EEED',
    20: '#A8DDDB',
    30: '#7DCDC8',
    40: '#51BCB6',
    50: '#26ABA4',
    60: '#21938D',
    70: '#1B7B76',
    80: '#16635F',
    90: '#114B48',
    100: '#0B3331',
  },
  green: {
    10: '#DBF6E8',
    20: '#A7EAC7',
    30: '#73DEA7',
    40: '#40D286',
    50: '#0CC665',
    60: '#0AA454',
    70: '#088343',
    80: '#066132',
    90: '#043F20',
    100: '#021E0F',
  },
  orange: {
    10: '#FFDEBE',
    20: '#FFD0A3',
    30: '#FFB46C',
    40: '#FF9936',
    50: '#FF7D00',
    60: '#E47000',
    70: '#AD5500',
    80: '#924800',
    90: '#5C2D00',
    100: '#3B1D00',
  },
  yellow: {
    10: '#FFF3DA',
    20: '#FFE9BC',
    30: '#FFDB94',
    40: '#FFCE6B',
    50: '#FFC043',
    60: '#DDA63A',
    70: '#AD832E',
    80: '#856423',
    90: '#5C4518',
    100: '#33260D',
  },
  gray: {
    0: '#F9F9F9',
    10: '#EDEDED',
    20: '#CDCDCE',
    30: '#9E9E9F',
    40: '#6F6F70',
    50: '#404041',
    A10: '#FFF',
    A20: '#F7F8F9',
    A30: '#F0F1F3',
    A90: '#010103',
    A100: '#000',
  },
  neutral: {
    white: '#FFF',
    10: '#F7F8F9',
    20: '#ECEFF3',
    30: '#E5E8EB',
    40: '#C5CAD3',
    50: '#919AAA',
    60: '#758195',
    70: '#5E6777',
    80: '#464D59',
    90: '#2F343C',
    100: '#1B1E23',
    black: '#000',
  },
  magenta: {
    10: '#FFE5F0',
    20: '#FFCCE1',
    30: '#FFA0C8',
    40: '#FF7DB3',
    50: '#FF529A',
    60: '#C43F77',
    70: '#8C2D55',
    80: '#66213E',
    90: '#401426',
    100: '#260C17',
  },
} as const;

export const colorByUse = {
  brand: {
    primary: {
      main: COLOR_TONE.teal['50'],
      light: '#bfe8e6', //TODO: add to COLOR_TONE this is the new color for NewKanbanCard
      // dark: '...',
      // contrastText: '...',
    },
    secondary: {
      main: COLOR_TONE.red['50'],
      // ...
    },
  },
  orderType: {
    bundle: {
      primary: {
        main: COLOR_TONE.teal['80'],
        contrastText: COLOR_TONE.teal['10'],
      },
    },
  },
  elevated: {
    regular: '#2122240A',
    strong: '#21222414',
    hard: '#21222429',
  },
  rtStatus: {
    searching: {
      bg: COLOR_TONE.gray['10'],
      text: COLOR_TONE.gray['50'],
    },
    onTheWay: {
      bg: COLOR_TONE.green['10'],
      text: COLOR_TONE.green['60'],
    },
    waiting: {
      bg: COLOR_TONE.orange['10'],
      text: COLOR_TONE.orange['60'],
    },
    waitingMuch: {
      bg: COLOR_TONE.red['10'],
      text: COLOR_TONE.red['50'],
    },
  },
  turbo: {
    danger: '#FF4242',
    tag: '#083410',
    warning: '#FFB73B',
  },
} as const;
